import React from "react";
import styled, { createGlobalStyle } from "styled-components";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { useSelectedTitleContext } from "./SelectedTitleContext";
// Create a global style to remove underline from all links
const GlobalStyle = createGlobalStyle`
  a {
    text-decoration: none;
    margin-top: 0.4rem;
    color:rgba(10, 20, 47, 1);
    font-size: 1.2rem;
    font-family: "Poppins", sans-serif;
    text-align: left;
  }
  @media only screen and (max-width: 768px) {
    a {
      text-decoration: none;
      color:rgba(10, 20, 47, 1);
      font-size: 0.7rem;
      text-align: left;
    }
  }
`;
const ExperienceFooter = () => {
  const { hostName } = useSelectedTitleContext();
  return (
    <>
      <GlobalStyle />
      <ContactInfo>
        <div className="imgg">
          {/* <img src="/spaceslogo.png" alt="logo" className="imggg" /> */}
          <Logo className="imggg" />
        </div>
        <div className="content">
          <div className="first">
            <p>+91 8473994822</p>
            <p>
              {hostName === "Bluetick-VR"
                ? "vishesh@bluetickvr.com"
                : "hi@convrse.ai"}
            </p>
          </div>
          <div className="sec">
            <Link to="/about">About</Link>
            <Link to="/our-solutions">Our Solution</Link>
            <Link to="/contact-us">Contact</Link>
            <Link to="/privacypolicy">Privacy Policy</Link>
            <Link to="/terms">Terms Of Use</Link>
            <Link to="/disclaimer">Disclaimer</Link>
          </div>
          <div className="third">
            <Link to="/facebook">Facebook</Link>
            <Link to="/twitter">Twitter</Link>
            <Link to="https://in.linkedin.com/company/convrse-spaces">
              Linkedin
            </Link>
            <Link to="https://www.instagram.com/convrse.spaces/?igsh=MXY3NmM4bjB5OTFybw%3D%3D">
              Instagram
            </Link>
          </div>
        </div>
      </ContactInfo>
      <CopyrightDiv>
        <p>
          Copyright Ⓒ2025 Propviz Technology Private Limited All rights
          reserved.
        </p>
      </CopyrightDiv>
    </>
  );
};
const ContactInfo = styled.div`
  box-shadow: 0 -8px 8px rgba(0, 0, 0, 0.05); /* Horizontal offset, vertical offset, blur radius, color */
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 98.5;
  height: 50vh;
  .imgg {
    width: 40%;
    display: flex;
    justify-content: center;
    align-items: center;
    .imggg {
      width: 40%;
    }
  }
  .content {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-family: "Poppins", sans-serif;
    width: 80%;
    .first {
      display: flex;
      flex-direction: column;
      width: 35%;
      font-family: "Poppins", sans-serif;
      .p {
        width: 60%;
        font-size: 1.2rem;
      }
    }
    .sec {
      display: flex;
      flex-direction: column;
      width: 30%;
      font-family: "Poppins", sans-serif;
    }
    .third {
      display: flex;
      flex-direction: column;
      width: 30%;
      font-family: "Poppins", sans-serif;
    }
  }
  @media only screen and (max-width: 768px) {
    display: flex;
    box-shadow: 0 -4px 4px rgba(0, 0, 0, 0.2);
    flex-direction: row;
    align-items: center;
    width: 140vw;
    height: 20vh;
    overflow: hidden;
    .img {
      width: 20vw;
      img {
        width: 60%;
      }
    }
    .content {
      display: flex;
      flex-direction: row;
      align-items: center;
      width: 80vw;
      .first {
        display: flex;
        flex-direction: column;
        width: 70%;
        .p {
          width: 60%;
          font-size: 0.7rem;
          margin-bottom: 0;
        }
        p {
          font-size: 0.7rem;
        }
      }
      .sec {
        display: flex;
        flex-direction: column;
        width: 30%;
      }
      .third {
        display: flex;
        flex-direction: column;
        width: 30%;
      }
    }
  }
`;

const CopyrightDiv = styled.div`
  margin-top: 0rem;
  margin-bottom: 2rem;
  text-align: center;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  p {
    margin: 0;
    padding: 0 1rem;
    font-family: "Poppins", sans-serif;
    font-size: 1rem;
    color: rgba(10, 20, 47, 1);
    text-align: center;
  }

  @media only screen and (max-width: 768px) {
    width: 100%;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 1rem;
    box-sizing: border-box;

    p {
      text-align: center;
      font-size: 0.7rem;
      padding: 0;
      margin: 0;
      width: 100%;
      word-wrap: break-word;
    }
  }
`;

export default ExperienceFooter;







